import React, { forwardRef } from 'react';
import SimpleBarReact, { Props as SimpleBarProps } from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import type SimpleBarCore from 'simplebar';
import { alpha, Box } from '@mui/material';
import ThemeManager from 'utils/ThemeManager';
import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/system';

interface ScrollbarProps extends SimpleBarProps {
  sx?: SxProps<Theme>;
  containOverscroll?: boolean;
}

export const Scrollbar = forwardRef<SimpleBarCore, ScrollbarProps>(
  ({ sx, containOverscroll = false, ...rest }, ref) => (
    <Box
      sx={{
        'position': 'relative',
        'minHeight': 0, // important inside flex parents
        'overflow': 'hidden', // prevent native scrollbar on this box
        '& .simplebar-track.simplebar-vertical': {
          right: 2,
          width: 6,
        },
        '& .simplebar-scrollbar:before': {
          borderRadius: 4,
          background: alpha(ThemeManager.getNeutral(6), 0.28),
        },
        ...(containOverscroll && {
          overscrollBehaviorY: 'contain',
          '& .simplebar-content-wrapper': {
            overscrollBehaviorY: 'contain',
          },
        }),
        ...sx,
      }}
    >
      <SimpleBarReact
        ref={ref}
        style={{ height: '100%' }} // ensure SimpleBar fills container
        autoHide={true} // default, but explicit
        {...rest}
      />
    </Box>
  ),
);

Scrollbar.displayName = 'Scrollbar';
